<div class="container">
  <div
    class="top"
    [ngStyle]="{ 'background-image': 'url(' + $safeNavigationMigration(tile()?.backgroundUrl) + ')' }">
    <h4>{{ tile()?.headline }}</h4>
  </div>
  <p [innerHTML]="$safeNavigationMigration(tile()?.text)"></p>
</div>
